import { useModalConfirmContext } from "./ModalConfirmContext";

export function useModalConfirm() {
  const { confirm } = useModalConfirmContext();
  return { confirm };
}
